export default "__VITE_ASSET__1zRUIkaN__"